module.exports = __webpack_public_path__ + "images/emoji/cloud.8fdb1e8c528b25cd3087.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cloud.png
// module id = IIIB
// module chunks = 13